import React from "react";
import DeactivatedStudentbyInstructor from "../../../components/DeactivatedStudentbyInstructor/DeactivatedStudentbyInstructor";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useDispatch } from "react-redux";
import { instructorDeactivatedStudentsAPI } from "../../../redux/features/intructorSlice";
import InstructorNotification from "../../../components/Notification/InstructorNotification";

const DeactivatedStudents = () => {
  const dispatch = useDispatch();

  const fetchInstructorDeactivatedStudents = async (token) => {
    return await dispatch(instructorDeactivatedStudentsAPI({ token })).unwrap();
  };

  return (
    <>
      {/* Top Bar */}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ad-heading-04 fw-bold mb-8">Deactivated Students</h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <InstructorNotification />
          </div>
        </div>
      </div>
      <div className="card-default-style px-14 py-40">
        <DeactivatedStudentbyInstructor fetchApi={fetchInstructorDeactivatedStudents} linkTo="/student-details" />
      </div>
      
    </>
  );
};

export default DeactivatedStudents;
